import { Dtos } from "@inrev/common";
import { Option } from "@inrev/core";
import { match, P } from "ts-pattern";

const includedInIndemnity = (
	contact:
		| Dtos.Company.Get.Response
		| Dtos.Admin.SuretyAccount.Get.Response.Company
		| Dtos.Individual.Get.Response,
): boolean =>
	match(contact)
		.with(
			{ config: { contract: { includeInIndemnity: P.select() } } },
			(includeInIndemnity) => includeInIndemnity !== false,
		)
		.otherwise(({ includeInIndemnity }) => includeInIndemnity !== false);

export const deriveIndemnitors = (
	source: {
		companies: (Dtos.Company.Get.Response | Dtos.Admin.SuretyAccount.Get.Response.Company)[];
		individuals: Dtos.Individual.Get.Response[];
	},
	indemnityAgreement: Option<Dtos.SuretyAccount.IndemnityAgreement.Get.Response>,
): Dtos.SuretyAccount.IndemnityAgreement.Get.Response["indemnitors"] => {
	if (indemnityAgreement) return indemnityAgreement.indemnitors;
	return {
		companies: source.companies
			.filter((c) => includedInIndemnity(c))
			.map((c) => ({ id: c.id, name: c.name })),
		individuals: source.individuals
			.filter((i) => includedInIndemnity(i))
			.map((i) => ({
				id: i.id,
				name: [i.firstName, i.lastName].filter(Boolean).join(" "),
				signerEmail: i.email,
			})),
	};
};

/** Required company indemnitors with no address. Indemnity can't go out until each has one. */
export const deriveCompanyIndemnitorsMissingAddress = (
	companies: (Dtos.Company.Get.Response | Dtos.Admin.SuretyAccount.Get.Response.Company)[],
): (Dtos.Company.Get.Response | Dtos.Admin.SuretyAccount.Get.Response.Company)[] =>
	companies.filter((c) => includedInIndemnity(c) && Option.isNone(c.address));

export const bondingLinesRequestHeaders = {
	Accept: Dtos.SuretyAccount.BondingLines.BONDING_LINES_MEDIA_TYPE,
};
